





















import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {MAFUser} from '@/store/User/types';
import {Action, State} from 'vuex-class';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:no-empty */

const namespace = 'userState';
@Component({
    components: {BButton},
})
export default class VerifyModalBody extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    public update: MAFUser;
    constructor() {
        super();
        this.update = this.self;
    }
    public async verify(verified: boolean) {
        // this.update.verified = verified;
        await this.updateSelfDoc(this.update.toPlainObj());
        this.close();
    }
    @Emit('close')
    public close() {
    }
}
